// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_bt-4";
export var collapsed = "_bt-1";
export var headerBar = "_bt-0";
export var leftHeaderContent = "_bt-3";
export var subjectContainer = "_bt-2";